export const FOOTER_SECTION_CONTENT = [
  {
    title: 'Services',
    links: [
      { name: 'Wedding Ceremonies', type: 'route', target: 'wedding-services' },
      { name: 'Home Poojas', type: 'route', target: 'home-pooja-services' },
      { name: 'Festival Celebrations', type: 'route', target: 'festival-services' },
      { name: 'Life Events', type: 'route', target: 'life-events' },
      { name: 'Spiritual Services', type: 'route', target: 'spiritual-services' }
    ]
  },
  {
    title: 'Company',
    links: [
      { name: 'About Us', type: 'event', target: 'about-us' },
      { name: 'How Booking Works', type: 'event', target: 'how-it-works' },
      { name: 'Become a Pandit', type: 'event', target: 'become-a-pandit' },
      { name: 'Corporate Pooja Services', type: 'event', target: 'corporate-services' },
      { name: 'Partner With Us', type: 'event', target: 'partner-with-us' }
    ]
  },
  {
    title: 'Support',
    links: [
      { name: 'Help Center', type: 'event', target: 'help-center' },
      { name: 'Track Booking', type: 'event', target: 'track-booking' },
      { name: 'Reschedule Or Cancel', type: 'event', target: 'reschedule-cancel' },
      { name: 'Pricing And Invoices', type: 'event', target: 'pricing-invoices' },
      { name: 'Contact Support (9 AM - 9 PM)', type: 'event', target: 'contact-support' }
    ]
  }
];
